"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdLaravelBoilerplate = require("cccisd-laravel-boilerplate");
var _cccisdLaravelNexus = require("cccisd-laravel-nexus");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _DeploymentPlayer = _interopRequireDefault(require("../DeploymentPlayer"));
var _DisplayMessage = _interopRequireDefault(require("../DisplayMessage"));
var _PlayerLayout = _interopRequireDefault(require("../PlayerLayout"));
var _cccisdLaravelLicensing = require("cccisd-laravel-licensing");
var _WithPasscode = _interopRequireDefault(require("../WithPasscode"));
var _getFlowProgress = _interopRequireDefault(require("./getFlowProgress.js"));
var _index = require("../navigations/courseWrapper/Mediator/index.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Boilerplate = window.cccisd.boilerplate;
var Fortress = window.cccisd.fortress;
var SessionStorage = window.sessionStorage;
var RESPONDENT_HASH_KEY = 'respondentHash';
var DeploymentEvaluator = /*#__PURE__*/function (_React$Component) {
  function DeploymentEvaluator() {
    var _this;
    _classCallCheck(this, DeploymentEvaluator);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DeploymentEvaluator, [].concat(args));
    _defineProperty(_this, "state", {
      deployment: {},
      isClosed: false,
      isLoading: true,
      show404: false,
      showLicensePrompt: false,
      productId: false,
      isPasscode: false
    });
    _defineProperty(_this, "getDeploymentData", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _data$license, _deployment$assignmen, _data$assignmentProgr, _data$assignmentProgr2, _data$assignmentProgr3;
      var _this$props, history, match, _match$params, deploymentHash, shortHash, actingPawn, sessionStorageKey, respondentHash, result, data, deployment;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this$props = _this.props, history = _this$props.history, match = _this$props.match;
            _match$params = match.params, deploymentHash = _match$params.deploymentHash, shortHash = _match$params.shortHash; // make sure we don't interpret the course wrapper tab as the shortHash
            if (shortHash && ('/' + shortHash).search(_index.courseWrapperTabWhitelistRegex) === 0) {
              shortHash = '';
            }
            actingPawn = Fortress.user.acting;
            if (deploymentHash) {
              _context.n = 1;
              break;
            }
            return _context.a(2, _this.setState({
              show404: true,
              isLoading: false
            }));
          case 1:
            // scope respondent hash to deployment hash so user can take 2 back-to-back anon surveys
            sessionStorageKey = "".concat(RESPONDENT_HASH_KEY, "_").concat(deploymentHash);
            respondentHash = shortHash || SessionStorage.getItem(sessionStorageKey);
            _context.n = 2;
            return _cccisdAxios["default"].post(Boilerplate.route('api.assignment.player.assignment'), _objectSpread({
              deploymentHash: deploymentHash
            }, respondentHash ? {
              respondentHash: respondentHash
            } : {}));
          case 2:
            result = _context.v;
            data = result.data.data;
            if (!(!data || !data.deployment)) {
              _context.n = 3;
              break;
            }
            return _context.a(2, _this.setState({
              show404: true,
              isLoading: false
            }));
          case 3:
            deployment = data.deployment;
            if (!data.isPasscode) {
              _context.n = 4;
              break;
            }
            return _context.a(2, _this.setState({
              isPasscode: true,
              deployment: _objectSpread(_objectSpread({}, (0, _omit2["default"])(deployment, ['role_handle'])), {}, {
                roleHandle: deployment.role_handle,
                surveylists: data.surveylist
              }),
              deploymentId: deployment.id,
              isLoading: false
            }));
          case 4:
            if (!(data.isLoginRequired || deployment.settings.requireLogin && actingPawn.role.handle === 'guest')) {
              _context.n = 5;
              break;
            }
            return _context.a(2, _this.setState({
              redirectToLogin: true,
              isLoading: false,
              deployment: deployment
            }));
          case 5:
            if (!(data !== null && data !== void 0 && (_data$license = data.license) !== null && _data$license !== void 0 && _data$license.product && !data.license.licenseStatus)) {
              _context.n = 6;
              break;
            }
            return _context.a(2, _this.setState({
              showLicensePrompt: true,
              productId: data.license.product.id,
              isLoading: false
            }));
          case 6:
            if (!(!(deployment !== null && deployment !== void 0 && deployment.id) || !(deployment !== null && deployment !== void 0 && (_deployment$assignmen = deployment.assignment) !== null && _deployment$assignmen !== void 0 && _deployment$assignmen.id))) {
              _context.n = 7;
              break;
            }
            return _context.a(2, _this.setState({
              show404: true,
              isLoading: false
            }));
          case 7:
            if (deployment.is_open) {
              _context.n = 8;
              break;
            }
            return _context.a(2, _this.setState({
              deployment: deployment,
              isClosed: true,
              isLoading: false
            }));
          case 8:
            if (deployment.type === 'anon') {
              SessionStorage.setItem(sessionStorageKey, data.pawn.respondent_hash);
              if (shortHash) {
                history.push("/d/".concat(deploymentHash));
              }
            }
            _this.setState({
              allSurveyProgress: data.surveyProgress,
              deployment: _objectSpread(_objectSpread({}, (0, _omit2["default"])(deployment, ['role_handle'])), {}, {
                roleHandle: deployment.role_handle,
                surveylists: data.surveylist
              }),
              deploymentId: deployment.id,
              pawnId: data.pawn.id,
              pawnHash: data.pawn.random_hash,
              flowProgress: (0, _getFlowProgress["default"])(data),
              language: (_data$assignmentProgr = data.assignmentProgress) === null || _data$assignmentProgr === void 0 ? void 0 : _data$assignmentProgr.language,
              flowList: (_data$assignmentProgr2 = data.assignmentProgress) === null || _data$assignmentProgr2 === void 0 ? void 0 : (_data$assignmentProgr3 = _data$assignmentProgr2.surveylist) === null || _data$assignmentProgr3 === void 0 ? void 0 : _data$assignmentProgr3.handle,
              isLoading: false
            });
          case 9:
            return _context.a(2);
        }
      }, _callee);
    })));
    _defineProperty(_this, "resetRespondentHash", function () {
      var _this$state$deploymen, _this$state$deploymen2;
      if (((_this$state$deploymen = _this.state.deployment) === null || _this$state$deploymen === void 0 ? void 0 : _this$state$deploymen.type) !== 'anon') {
        return;
      }
      var sessionStorageKey = "".concat(RESPONDENT_HASH_KEY, "_").concat((_this$state$deploymen2 = _this.state.deployment) === null || _this$state$deploymen2 === void 0 ? void 0 : _this$state$deploymen2.hash);
      SessionStorage.removeItem(sessionStorageKey);
    });
    _defineProperty(_this, "obtainAccess", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var match, _match$params2, deploymentHash, shortHash;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            match = _this.props.match;
            _match$params2 = match.params, deploymentHash = _match$params2.deploymentHash, shortHash = _match$params2.shortHash;
            _context2.n = 1;
            return _cccisdAxios["default"].get(Boilerplate.route('api.assignmentDeployment.obtainAccess', _objectSpread({
              deploymentHash: deploymentHash
            }, shortHash ? {
              shortHash: shortHash
            } : {}))).then(function () {
              window.location.reload();
            })["catch"](function (err) {
              console.error(err);
              _this.setState({
                show404: true
              });
            });
          case 1:
            return _context2.a(2);
        }
      }, _callee2);
    })));
    return _this;
  }
  _inherits(DeploymentEvaluator, _React$Component);
  return _createClass(DeploymentEvaluator, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.getDeploymentData();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        allSurveyProgress = _this$state.allSurveyProgress,
        deployment = _this$state.deployment,
        deploymentId = _this$state.deploymentId,
        isClosed = _this$state.isClosed,
        isLoading = _this$state.isLoading,
        pawnHash = _this$state.pawnHash,
        pawnId = _this$state.pawnId,
        redirectToLogin = _this$state.redirectToLogin,
        show404 = _this$state.show404,
        showLicensePrompt = _this$state.showLicensePrompt,
        productId = _this$state.productId,
        isPasscode = _this$state.isPasscode,
        flowProgress = _this$state.flowProgress,
        language = _this$state.language,
        flowList = _this$state.flowList;
      var _this$props2 = this.props,
        errorLayout = _this$props2.errorLayout,
        _this$props2$registra = _this$props2.registrationUrlsByRole,
        registrationUrlsByRole = _this$props2$registra === void 0 ? {} : _this$props2$registra;
      if (isLoading) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: true
        });
      }
      if (redirectToLogin) {
        var registrationUrl = registrationUrlsByRole[deployment.roleHandle || deployment.role_handle];
        if (registrationUrl) {
          return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
            to: {
              pathname: registrationUrl,
              search: "?redirectUrl=".concat(window.location.href)
            }
          });
        }
        return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelNexus.AuthRedirect, null);
      }
      if (show404) {
        var ErrorLayout = errorLayout;
        return /*#__PURE__*/_react["default"].createElement(ErrorLayout, null, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelBoilerplate.NotFound, {
          force404: true
        }));
      }
      if (showLicensePrompt) {
        return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelLicensing.LicensePrompt, {
          productId: productId,
          obtainAccess: function obtainAccess() {
            return _this2.obtainAccess();
          }
        });
      }
      if (isClosed) {
        var assignmentSettings = deployment.assignment && deployment.assignment.settings || {};
        var deploymentSettings = deployment && deployment.settings || {};
        return /*#__PURE__*/_react["default"].createElement(_PlayerLayout["default"], {
          frameHandle: assignmentSettings.frameStyleId,
          showHeader: assignmentSettings.showHeader,
          showFooter: assignmentSettings.showFooter,
          settings: assignmentSettings.frameStyleSettings || {},
          navigation: assignmentSettings.navigation
        }, /*#__PURE__*/_react["default"].createElement(_DisplayMessage["default"], {
          message: deploymentSettings.closedMessage || ' '
        }));
      }
      if (isPasscode) {
        var passcodeSettings = deployment && deployment.settings || {};
        return /*#__PURE__*/_react["default"].createElement(_WithPasscode["default"], {
          passcodeSettings: passcodeSettings,
          deploymentId: deploymentId
        });
      }
      var componentProps = _objectSpread(_objectSpread({}, (0, _omit2["default"])(this.props, ['history', 'location', 'match', 'staticContext', 'registrationUrlsByRole'])), {}, {
        deploymentId: deploymentId,
        pawnHash: pawnHash,
        pawnId: pawnId,
        onComplete: this.resetRespondentHash,
        onLogout: this.resetRespondentHash,
        preloadedState: {
          allSurveyProgress: allSurveyProgress,
          assignmentData: _objectSpread(_objectSpread({}, deployment.assignment.settings), {}, {
            assignmentId: deployment.assignment.id,
            handle: deployment.assignment.handle,
            label: deployment.assignment.label,
            surveylists: deployment.surveylists
          }),
          deploymentId: deploymentId,
          parentDeploymentId: deployment.parent_deployment_id,
          relatedDeploymentId: deployment.related_deployment_id,
          settings: deployment.settings,
          showReviewButtonOnCompletion: (!deployment.settings.postCompletionAction || deployment.settings.postCompletionAction === 'message') && !deployment.settings.logoutOnCompletion && deployment.settings.showReviewButtonOnCompletion,
          flowProgress: flowProgress,
          language: language,
          flowList: flowList
        }
      });
      return /*#__PURE__*/_react["default"].createElement(_DeploymentPlayer["default"], componentProps);
    }
  }]);
}(_react["default"].Component);
_defineProperty(DeploymentEvaluator, "propTypes", {
  /** The layout to use for the 404 page */
  errorLayout: _propTypes["default"].func,
  /** Should we skip saving everything and not run any pre/postFlowRoutes? */
  isPreviewMode: _propTypes["default"].bool,
  /* From redux-router */
  history: _propTypes["default"].object.isRequired,
  match: _propTypes["default"].object.isRequired,
  /** An alternate React Component to replace default Mediator */
  mediator: _propTypes["default"].func,
  /* An object whose keys are role handles and values are registration urls */
  registrationUrlsByRole: _propTypes["default"].object
});
_defineProperty(DeploymentEvaluator, "defaultProps", {
  errorLayout: function errorLayout(_ref3) {
    var children = _ref3.children;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "container"
    }, children);
  }
});
var _default = exports["default"] = DeploymentEvaluator;